import { Button, type ButtonProps, Drawer, Stack } from '@mui/material'
import React, { useState } from 'react'

import Icon from 'components/Icon'
import { type ThirdPartyExternalIntegration } from 'components/rbac-settings/teams/integrations/third-party/third-party-account-integrations-utils'
import { ThirdPartyAuth } from 'components/rbac-settings/teams/integrations/third-party/ThirdPartyAuth'
import { ThirdPartySelectMenu } from 'components/rbac-settings/teams/integrations/third-party/ThirdPartySelectMenu'
import { useObservabilityToolAuthenticationContext } from 'context/status-checks/ObservabilityToolAuthenticationContext'
import { usePopoverState } from 'hooks/use-popover-state'
import {
  ObservabilityToolType,
  type TeamExternalIntegration
} from 'types/api/status-checks/status-check'

const DEFAULT_OPTION = ObservabilityToolType.AWS

export function ThirdPartyAccountDrawer({
  buttonProps,
  externalIntegrations,
  mode = 'add',
  selectedIntegration
}: {
  buttonProps?: Omit<ButtonProps, 'children' | 'onClick'>
  externalIntegrations: TeamExternalIntegration[]
  mode?: 'add' | 'edit'
  selectedIntegration?: TeamExternalIntegration
}) {
  const { setIsEdit } = useObservabilityToolAuthenticationContext()
  const drawerState = usePopoverState()

  const [integrationTypeSelection, setIntegrationTypeSelection] =
    useState<ThirdPartyExternalIntegration>(DEFAULT_OPTION)

  const isEdit = selectedIntegration !== undefined

  const handleOpen = () => {
    drawerState.open()
    setIsEdit(isEdit)
  }

  const handleClose = () => {
    drawerState.close()
    setIsEdit(false)
  }

  return (
    <>
      <Button
        size="small"
        startIcon={<Icon icon={mode === 'add' ? 'plus' : 'edit'} />}
        variant="contained"
        {...buttonProps}
        onClick={handleOpen}
      >
        {mode === 'add' ? 'ID' : 'Edit'}
      </Button>
      <Drawer
        anchor="right"
        open={drawerState.isOpen}
        PaperProps={{ sx: { width: 'min(1200px, 90%)' } }}
        onClose={handleClose}
      >
        <Stack sx={{ padding: 3 }}>
          {!isEdit && (
            <ThirdPartySelectMenu
              selected={integrationTypeSelection}
              onSelect={setIntegrationTypeSelection}
            />
          )}
          <ThirdPartyAuth
            externalIntegrations={externalIntegrations}
            selectedIntegration={selectedIntegration}
            type={
              selectedIntegration?.observabilityToolType ??
              integrationTypeSelection
            }
            onClose={handleClose}
          />
        </Stack>
      </Drawer>
    </>
  )
}
